import PreparationDelayWidget from './preparation-widget';

export default {
	PreparationDelayWidget
};
